import {gql} from '@apollo/client';

export const MUTATION_VISIT = gql`
    mutation visitGetMoneyKz ($session: String!, $token: String, $provider: String) {
        visitGetMoneyKz(session: $session, token: $token, provider: $provider) {
            done
        }
    }
`